/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API
 * API for managing Y-sports related stuff
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Court } from './Court';
import {
    CourtFromJSON,
    CourtFromJSONTyped,
    CourtToJSON,
} from './Court';
import type { Team } from './Team';
import {
    TeamFromJSON,
    TeamFromJSONTyped,
    TeamToJSON,
} from './Team';
import type { TournamentCategory } from './TournamentCategory';
import {
    TournamentCategoryFromJSON,
    TournamentCategoryFromJSONTyped,
    TournamentCategoryToJSON,
} from './TournamentCategory';

/**
 * 
 * @export
 * @interface Match
 */
export interface Match {
    /**
     * 
     * @type {string}
     * @memberof Match
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Match
     */
    tournamentId?: string;
    /**
     * 
     * @type {Team}
     * @memberof Match
     */
    teamA?: Team;
    /**
     * 
     * @type {Team}
     * @memberof Match
     */
    teamB?: Team;
    /**
     * 
     * @type {TournamentCategory}
     * @memberof Match
     */
    category?: TournamentCategory;
    /**
     * 
     * @type {string}
     * @memberof Match
     */
    group?: string;
    /**
     * Optional display label for the match (e.g., Group A 1st vs Group B 2nd)
     * @type {string}
     * @memberof Match
     */
    label?: string;
    /**
     * 
     * @type {Date}
     * @memberof Match
     */
    matchTime?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof Match
     */
    dynamic?: boolean;
    /**
     * Duration of each period in minutes
     * @type {number}
     * @memberof Match
     */
    periodDurationMinutes?: number;
    /**
     * 
     * @type {number}
     * @memberof Match
     */
    periodCount?: number;
    /**
     * Total scheduling block minutes for this match (periods + internal breaks)
     * @type {number}
     * @memberof Match
     */
    blockDurationMinutes?: number;
    /**
     * Current score of team A
     * @type {number}
     * @memberof Match
     */
    teamAScore?: number;
    /**
     * Current score of team B
     * @type {number}
     * @memberof Match
     */
    teamBScore?: number;
    /**
     * Current status of the match
     * @type {string}
     * @memberof Match
     */
    status?: MatchStatus;
    /**
     * 
     * @type {Team}
     * @memberof Match
     */
    winnerTeam?: Team;
    /**
     * 
     * @type {Court}
     * @memberof Match
     */
    court?: Court;
    /**
     * Optional public streaming URL for this match
     * @type {string}
     * @memberof Match
     */
    streamingUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Match
     */
    stageId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Match
     */
    groupId?: string | null;
    /**
     * Round number for round-robin matches (default 1)
     * @type {number}
     * @memberof Match
     */
    roundNumber?: number;
}

/**
* @export
* @enum {string}
*/
export enum MatchStatus {
    Scheduled = 'SCHEDULED',
    InProgress = 'IN_PROGRESS',
    Finished = 'FINISHED'
}


/**
 * Check if a given object implements the Match interface.
 */
export function instanceOfMatch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MatchFromJSON(json: any): Match {
    return MatchFromJSONTyped(json, false);
}

export function MatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): Match {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'tournamentId': !exists(json, 'tournamentId') ? undefined : json['tournamentId'],
        'teamA': !exists(json, 'teamA') ? undefined : TeamFromJSON(json['teamA']),
        'teamB': !exists(json, 'teamB') ? undefined : TeamFromJSON(json['teamB']),
        'category': !exists(json, 'category') ? undefined : TournamentCategoryFromJSON(json['category']),
        'group': !exists(json, 'group') ? undefined : json['group'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'matchTime': !exists(json, 'matchTime') ? undefined : (new Date(json['matchTime'])),
        'dynamic': !exists(json, 'dynamic') ? undefined : json['dynamic'],
        'periodDurationMinutes': !exists(json, 'periodDurationMinutes') ? undefined : json['periodDurationMinutes'],
        'periodCount': !exists(json, 'periodCount') ? undefined : json['periodCount'],
        'blockDurationMinutes': !exists(json, 'blockDurationMinutes') ? undefined : json['blockDurationMinutes'],
        'teamAScore': !exists(json, 'teamAScore') ? undefined : json['teamAScore'],
        'teamBScore': !exists(json, 'teamBScore') ? undefined : json['teamBScore'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'winnerTeam': !exists(json, 'winnerTeam') ? undefined : TeamFromJSON(json['winnerTeam']),
        'court': !exists(json, 'court') ? undefined : CourtFromJSON(json['court']),
        'streamingUrl': !exists(json, 'streamingUrl') ? undefined : json['streamingUrl'],
        'stageId': !exists(json, 'stageId') ? undefined : json['stageId'],
        'groupId': !exists(json, 'groupId') ? undefined : json['groupId'],
        'roundNumber': !exists(json, 'roundNumber') ? undefined : json['roundNumber'],
    };
}

export function MatchToJSON(value?: Match | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'tournamentId': value.tournamentId,
        'teamA': TeamToJSON(value.teamA),
        'teamB': TeamToJSON(value.teamB),
        'category': TournamentCategoryToJSON(value.category),
        'group': value.group,
        'label': value.label,
        'matchTime': value.matchTime === undefined ? undefined : (value.matchTime.toISOString()),
        'dynamic': value.dynamic,
        'periodDurationMinutes': value.periodDurationMinutes,
        'periodCount': value.periodCount,
        'blockDurationMinutes': value.blockDurationMinutes,
        'teamAScore': value.teamAScore,
        'teamBScore': value.teamBScore,
        'status': value.status,
        'winnerTeam': TeamToJSON(value.winnerTeam),
        'court': CourtToJSON(value.court),
        'streamingUrl': value.streamingUrl,
        'stageId': value.stageId,
        'groupId': value.groupId,
        'roundNumber': value.roundNumber,
    };
}

